import React from 'react';
import classNames from 'classnames/bind';
import { Picture } from "../../Picture";
import { Video } from "../Video";
import style from "./style.module.pcss";
var cn = classNames.bind(style);
var MediaBackground = function MediaBackground(_ref) {
  var img = _ref.img,
    video = _ref.video,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('media', className),
    "data-t-id": "Media-MediaBackground"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('media__content')
  }, img ? /*#__PURE__*/React.createElement(Picture, img) : /*#__PURE__*/React.createElement(Video, video)));
};
export { MediaBackground };